import { FormGroup, TextField, Autocomplete } from '@mui/material';
import React from 'react';

export default function AutocompleteField({
  data, value, getOptionLabel, onChange, label, fullWidth, size, disabled, noOptionsText, formik, error,
}) {
  return (
    <FormGroup>
      <Autocomplete
        disabled={!!disabled}
        noOptionsText={noOptionsText || 'Sem opções'}
        name={label}
        size={size}
        options={data}
        value={value}
        getOptionLabel={(option) => `${option[getOptionLabel]}`}
        onChange={onChange}
        fullWidth={fullWidth}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            error={formik ? formik.touched[error] && formik.errors[error] : null}
            helperText={formik ? formik.touched[error] && formik.errors[error] : null}
          />
        )}
        color="primary"
      />
    </FormGroup>
  );
}
